import { useCallback } from 'react';
import { useUpdateSmartListMutation } from 'shared/hooks/queries/use-update-smart-list-mutation';
import { useUser } from 'shared/hooks/use-user';
import { UpdateSmartList } from 'shared/types/smart-list';

export const useUpdateSmartList = () => {
  const user = useUser();
  const { mutateAsync: updateSmartList } = useUpdateSmartListMutation();

  const submit = useCallback(
    async (smartList: UpdateSmartList) => {
      if (!user) {
        return;
      }

      await updateSmartList({
        uid: user.uid,
        smartList,
      });
    },
    [updateSmartList, user],
  );

  return { submit };
};
